const _excluded = ["value", "multi", "onChange", "required", "parameterId"],
  _excluded2 = ["value", "multi", "onChange", "required", "parameterId", "valueText"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { InputAsyncMultiSelect, InputAsyncSelect, InputMultiSelect, InputSelect } from '@isyc-react/form/modules/input/select';
import { useParameterTemplateReadQuery } from "./parameter-template-read.query";
import { Spinner } from '@isyc-react/design/bootstrap';
import { useParameterTemplateReadAsyncPromise } from "./parameter-template-read-async.query";
const sep = ',';
export const InputParameterSelect = props => {
  var _value$;
  const {
      value: valueProp = null,
      multi = false,
      onChange,
      required,
      parameterId
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    data,
    loading,
    error
  } = useParameterTemplateReadQuery({
    variables: {
      id: parameterId
    }
  });
  const options = React.useMemo(() => {
    const options = [];
    if (data && data.parameterTemplate_read && data.parameterTemplate_read.defaultValues) {
      data.parameterTemplate_read.defaultValues.filter(df => df !== null).forEach(df => {
        options.push({
          label: df.text,
          value: df.code
        });
      });
    }
    return options;
  }, [data]);
  const value = React.useMemo(() => {
    return valueProp ? valueProp.split(sep).map(v => ({
      value: v
    })) : [];
  }, [valueProp]);

  // TODO error and improve loading

  return /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(Spinner, {
    animation: "border",
    size: "sm"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, multi ? /*#__PURE__*/React.createElement(InputMultiSelect, _extends({
    value: value,
    onChange: c => {
      onChange && onChange(c.map(c => c.value).join(sep));
    },
    options: options,
    isClearable: !required
  }, rest)) : /*#__PURE__*/React.createElement(InputSelect, _extends({
    value: (_value$ = value[0]) !== null && _value$ !== void 0 ? _value$ : null,
    onChange: c => {
      var _c$value;
      onChange && onChange((_c$value = c === null || c === void 0 ? void 0 : c.value) !== null && _c$value !== void 0 ? _c$value : '');
    },
    options: options,
    isClearable: !required
  }, rest))));
};
export const InputParameterSelectAsync = props => {
  const {
      value: valueProp = null,
      multi = false,
      onChange,
      required,
      parameterId,
      valueText
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  const asyncCall = useParameterTemplateReadAsyncPromise();
  const callAsync = (inputValue, resolve) => {
    asyncCall({
      id: parameterId,
      search: inputValue
    }).then(res => resolve(res !== null && res !== void 0 && res.data.parameterTemplate_read_async ? res === null || res === void 0 ? void 0 : res.data.parameterTemplate_read_async.map(df => {
      return {
        label: df.text,
        value: df.code
      };
    }) : [])).catch(() => resolve([]));
  };
  const values = React.useMemo(() => {
    const valueTextsArr = valueText.split(sep);
    return valueProp ? valueProp.split(sep).map((v, indx) => {
      var _valueTextsArr$indx;
      return {
        value: v,
        label: (_valueTextsArr$indx = valueTextsArr[indx]) !== null && _valueTextsArr$indx !== void 0 ? _valueTextsArr$indx : ''
      };
    }) : [];
  }, [valueProp, valueText]);

  // TODO error and improve loading

  return /*#__PURE__*/React.createElement(React.Fragment, null, multi ? /*#__PURE__*/React.createElement(InputAsyncMultiSelect, _extends({
    defaultValue: values,
    promise: callAsync,
    onChange: c => {
      onChange && onChange(c.map(c => c.value).join(sep));
    },
    isClearable: !required
  }, rest)) : /*#__PURE__*/React.createElement(InputAsyncSelect, _extends({
    value: values && values[0] ? values[0] : undefined,
    promise: callAsync,
    onChange: c => {
      var _c$value2;
      onChange && onChange((_c$value2 = c === null || c === void 0 ? void 0 : c.value) !== null && _c$value2 !== void 0 ? _c$value2 : '');
    },
    isClearable: !required
  }, rest)));
};